import apiRequest from './apiRequest';

export default async function postFavorite(
  jobID: string,
  animationNumber: number,
) {
  return await apiRequest(
    'mogen-orchestration',
    `/jobs/${jobID}/favorite?animationNumber=${animationNumber}`,
    {
      method: 'POST',
    },
  );
}
